import React from "react";
// Customizable Area Start
import { Box, Typography, Snackbar, Grid, styled } from "@material-ui/core";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import CustomInput from "../../../components/src/customComponent/cutomInput.web";
import EditLateDeliveryConfigController, { Props, configJSON } from "./EditLateDeliveryConfigController.web";
import Alert from "@material-ui/lab/Alert";
import CustomLoader from "../../../components/src/customComponents/CustomLoader.web";
import CustomSwitch from "../../../components/src/CustomSwitch.web";
import { Formik, Form } from "formik";
// Customizable Area End

const theme = createTheme({});

export default class EditLateDeliveryConfig extends EditLateDeliveryConfigController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    return (
      <ThemeProvider theme={theme}>
        <StyledMainBox>
          <Box>
            <CustomLoader loading={this.state.loading || this.state.addBtnLoading} />
            <Box className="titleContainer">
              <Typography className="titleContainerText">
                Edit Late Delivery Configuration
              </Typography>
            </Box>

            <Formik
              enableReinitialize
              validateOnBlur={true}
              initialValues={{
                ...this.state.initialValues,
              }}
              onSubmit={(values) => {
                this.updateLateDeliveryConfig(values);
              }}
              validationSchema={this.FormSchema}
            >
              {({ errors, values, handleSubmit, handleChange, touched, setFieldValue }) => {
                return (
                  <Form onSubmit={handleSubmit}>
                    <Box className="addEditCard">
                      <Box className="editInputBox">
                        <Grid container spacing={4}>
                          <Grid item xs={12} md={6}>
                            <TextLabel>Name</TextLabel>
                            <CustomInput
                              name="name"
                              placeholder="Enter name"
                              onChange={handleChange}
                              inputError={touched.name && errors.name}
                              value={values.name}
                            />
                            {touched.name && errors.name && (
                              <Typography className="error">{errors.name}</Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextLabel>Hours</TextLabel>
                            <CustomInput
                              name="hours"
                              placeholder="Enter hours"
                              onChange={handleChange}
                              inputError={touched.hours && errors.hours}
                              value={values.hours}
                            />
                            {touched.hours && errors.hours && (
                              <Typography className="error">{errors.hours}</Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <TextLabel>Color</TextLabel>
                            <Box style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                              <input
                                type="color"
                                value={values.color}
                                onChange={(e) => setFieldValue("color", e.target.value)}
                                style={{
                                  width: "56px",
                                  height: "56px",
                                  border: "1px solid #ccc",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              />
                              <CustomInput
                                name="color"
                                placeholder="#000000"
                                onChange={handleChange}
                                inputError={touched.color && errors.color}
                                value={values.color}
                              />
                            </Box>
                            {touched.color && errors.color && (
                              <Typography className="error">{errors.color}</Typography>
                            )}
                          </Grid>
                          <Grid item xs={12} md={6}>
                            <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                              <TextLabel>Status</TextLabel>
                              <CustomSwitch
                                checked={values.isActive}
                                onChange={(checked) => setFieldValue("isActive", checked)}
                              />
                            </Box>
                          </Grid>
                        </Grid>
                      </Box>
                    </Box>
                    <Box>
                      <BottomContainer>
                        <button
                          onClick={() => this.handleCancelForm()}
                          className="cancel"
                          type="button"
                        >
                          Cancel
                        </button>
                        <button
                          className="add"
                          type="submit"
                        >
                          Update
                        </button>
                      </BottomContainer>
                    </Box>
                  </Form>
                );
              }}
            </Formik>
            <Snackbar
              anchorOrigin={{
                vertical: "top",
                horizontal: "center",
              }}
              autoHideDuration={2000}
              open={this.state.snackbar.open}
              onClose={this.handleCloseSnackbar}
            >
              <Alert severity={this.state.snackbar.severity}>{this.state.snackbar.message}</Alert>
            </Snackbar>
          </Box>
        </StyledMainBox>
      </ThemeProvider>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
const StyledMainBox = styled(Box)({
  fontFamily: "Montserrat",
  padding: "32px",
  "& .titleContainer": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "32px",
  },
  "& .titleContainerText": {
    fontSize: "24px",
    fontWeight: 600,
    lineHeight: "29px",
  },
  "& .addEditCard": {
    background: "#FFFFFF",
    borderRadius: "8px",
    padding: "24px",
  },
  "& .editInputBox": {
    width: "100%",
  },
  "& .error": {
    color: "#DC2626",
    fontSize: "12px",
    marginTop: "4px",
  },
});

const TextLabel = styled("label")({
  display: "block",
  fontSize: 16,
  lineHeight: "24px",
  fontWeight: 600,
  paddingBottom: 4,
  color: "#334155",
  "@media only screen and (max-width: 1024px)": {
    fontSize: "13px",
  },
});

const BottomContainer = styled("div")({
  gap: 32,
  display: "flex",
  paddingTop: 48,
  "& > button": {
    fontSize: 16,
    padding: 16,
    minWidth: 126,
    border: "none",
    fontWeight: 700,
    borderRadius: 8,
    cursor: "pointer",
    lineHeight: "24px",
    alignItems: "center",
    display: "inline-flex",
    justifyContent: "center",
    fontFamily: "Montserrat",
    "&:disabled": {
      opacity: 0.5,
    },
  },
  "& > .add": {
    color: "white",
    background: "#204B9C",
    "@media only screen and (max-width: 1024px)": {
      width: "126px",
      height: "44px",
    },
  },
  "& > .cancel": {
    color: "#64748B",
    background: "#F1F5F9",
    "@media only screen and (max-width: 1024px)": {
      width: "126px",
      height: "44px",
    },
  },
});
// Customizable Area End
